import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getUserRole } from "./Auth";

const DeleteConfirmation = ({
  setShowDeleteModal,
  showDeleteModal,
  tableName,
  id,
  onConfirmDelete, // callback to perform actual delete
}) => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (getUserRole() === "admin") {
      setIsAdmin(true);
    }
  }, []);

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  const handleDelete = () => {
    if (onConfirmDelete && typeof onConfirmDelete === "function") {
      onConfirmDelete(id, tableName);
    }
    handleClose();
  };

  return (
    <Dialog open={showDeleteModal} onClose={handleClose}>
      {!isAdmin ? (
        <>
          <DialogTitle>Alert</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <DialogContentText>
              <strong>
                You are not authorised to perform delete operation. Please
                contact your administration for further details.
              </strong>
            </DialogContentText>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this <b>{tableName}</b>{" "}
              (ID: <b>{id}</b>)?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined" color="primary">
              No
            </Button>
            <Button
              onClick={handleDelete}
              variant="contained"
              color="error"
              autoFocus
            >
              Yes, Delete
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default DeleteConfirmation;
